// extracted by mini-css-extract-plugin
module.exports = {"header":"Buttons_header__tODfW","btn":"Buttons_btn__4gVk5"};